<template>
  <FileUploadsTable />
</template>
<script>

import FileUploadsTable from "@/v3components/Datatables/FileUploadsTable.vue"

export default {
  name: "FileUploads",
  components: { FileUploadsTable }
}
</script>
